// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1xyhK","subheader":"ReorderModal_subheader__3vAOo","listWrap":"ReorderModal_listWrap__ZeBbF"};